import { StocksApiRemoteService } from '../../Services/api/stocks/stocks-service'
import { ICreateStockPayload } from '../../Services/api/stocks/stocks.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreateStockUseCase
implements IFormUsecase<ICreateStockPayload, void> {
  constructor (private readonly StocksApi: StocksApiRemoteService) {}
    

  public async handle (
    data: ICreateStockPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.StocksApi.create(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
